/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './dropdown.module.scss';

const ApproverDropdown = ({ title, value, onChange, approverOptions }) => {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };
  return (
    <div>
      <div className={styles.title}>{title}</div>
      <select
        value={value || ''}
        onChange={handleChange}
        className={styles['select-dropdown']}
      >
        <option value="">Select {title}</option>
        {approverOptions.map((option) => (
          <option key={option.roleId} value={option.roleName}>
            {option.roleName}
          </option>
        ))}
      </select>
    </div>
  );
};

ApproverDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.shape({
    roleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    roleName: PropTypes.string.isRequired,
  }),
  onChange: PropTypes.func.isRequired,
  approverOptions: PropTypes.arrayOf(
    PropTypes.shape({
      roleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      roleName: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ApproverDropdown;
